import firebase from "@firebase/app";
import "@firebase/auth";
import "@firebase/firestore";
import "@firebase/storage";

const config = {
    apiKey: "AIzaSyAaAAD-NzxWWSb_do0J6oVlnwpu9VPXkzE",
    authDomain: "code-app-3e8d0.firebaseapp.com",
    databaseURL: "https://code-app-3e8d0.firebaseio.com",
    projectId: "code-app-3e8d0",
    storageBucket: "",
    messagingSenderId: "274856361908",
    appId: "1:274856361908:web:eb6b4c043f812c38"
  };

  export default {
    init() {
        firebase.initializeApp(config);
    }
  }